import { z } from 'zod';

export const StreamPacketSchema = z.object({
  macAddress: z.string(),
  accelerometer: z.number(),
  gyroscope: z.number(),
  quaternion: z.any(),
});

export type StreamPacket = z.infer<typeof StreamPacketSchema>;
